import { computed as i, createElementBlock as t, openBlock as d, normalizeClass as n, renderSlot as c } from "vue";
/* empty css                  */
const r = ["role"], o = {
  key: 0,
  class: "ds-shimmer"
}, f = /* @__PURE__ */ Object.assign({
  name: "DsTableColumn"
}, {
  __name: "table-column",
  props: {
    column: { type: Object, required: !0 },
    isFirst: { type: Boolean, required: !0 },
    isLast: { type: Boolean, required: !0 },
    isHeader: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 },
    stretch: { type: Boolean, default: !1 }
  },
  setup(e) {
    const s = e, l = i(() => s.isHeader ? "rowheader" : "cell");
    return (a, u) => (d(), t("div", {
      role: l.value,
      class: n(["ds-table__col", [
        `ds-table__col--${e.column.cols}`,
        `ds-text-align-${e.column.align}`,
        { "ds-padding-left-0": e.isFirst },
        { "ds-lg-padding-left-0 ds-padding-left-24": !e.isFirst && !e.isLast && !e.isHeader && e.stretch },
        { "ds-md-padding-left-0  ds-lg-padding-left-0 ds-padding-left-24": e.isFirst && e.stretch },
        { "ds-padding-right-0": e.isLast },
        { "ds-padding-right-24 ds-sm-table__col--stretched": e.isLast && e.stretch },
        { "ds-table__header": e.isHeader },
        { "ds-md-table__col--stretched ": e.stretch && e.isHeader }
      ]])
    }, [
      e.isLoading ? (d(), t("div", o)) : c(a.$slots, "default", { key: 1 })
    ], 10, r));
  }
});
export {
  f as default
};
